<template>
  <div class="enterprise-form">
    <el-form
      ref="enterpriseForm"
      :model="enterpriseForm"
      :rules="rules"
      label-position="left"
      label-width="80px"
      status-icon
    >
      <el-form-item prop="enterpriseName" label="团队名称">
        <el-input
          v-model="enterpriseForm.enterpriseName"
          @input="generateAcronym"
          placeholder="团队名称仅能修改一次，请慎重填写。"
        />
      </el-form-item>

      <el-form-item label="团队编码" prop="enterpriseCode">
        <el-input v-model="enterpriseForm.enterpriseCode" placeholder="团队编码,根据团队名称生成，也可手动输入" />
      </el-form-item>

      <el-form-item prop="selectedCity" label="所在地">
        <city-picker class="city-picker" ref="cityPicker" v-model="enterpriseForm.selectedCity" />
      </el-form-item>

      <el-form-item prop="type" label="所属行业">
        <el-cascader v-model="enterpriseForm.type" :options="industryTypes" class="industry" />
      </el-form-item>

      <el-form-item prop="scaleItemId" label="人员规模">
        <el-select
          v-model="enterpriseForm.scaleItemId"
          clearable
          placeholder="请选择人员规模"
          class="employee-scale"
        >
          <el-option
            v-for="item in peopleScaleList"
            :key="item.id"
            :label="item.itemName"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
    </el-form>

    <el-button type="primary" @click="confirmCreateEnterprise" class="submit-button">提交</el-button>
  </div>
</template>


<script>
import CityPicker from "@/components/business/CityPicker";

import {
  industryTypes,
  createEnterpriseFormRules,
  initCreateEnterpriseForm
} from "../constant";

export default {
  components: {
    CityPicker
  },

  data() {
    return {
      peopleScaleList: [],
      industryTypes: industryTypes,
      rules: createEnterpriseFormRules,

      enterpriseForm: this.$js.deepClone(initCreateEnterpriseForm)
    };
  },

  mounted() {
    this.setPeopleScaleList();
  },

  methods: {
    confirmCreateEnterprise() {
      this.$refs.enterpriseForm.validate(valid => {
        if (valid) {
          this.submitCreateEnterprise();
        }
      });
    },

    async submitCreateEnterprise() {
      const requestData = this.getCreateEnterpriseRequestData();
      await this.$api.addEnterprise(requestData);

      this.$Modal.success({
        title: "创建团队成功！",
        onOk: _ => {
          this.$router.push({ path: "select" });
        }
      });
    },

    getCreateEnterpriseRequestData() {
      const address = this.getEnterpriseAddress();
      const {
        enterpriseName,
        enterpriseCode,
        scaleItemId
      } = this.enterpriseForm;

      return {
        address: address,
        enterpriseName,
        enterpriseCode,
        scaleItemId,
        industryItemId: 0
      };
    },

    getEnterpriseAddress() {
      const addressObj = this.$refs.cityPicker.selectedCityDetails;
      const address = `${addressObj.provinceName}-${addressObj.cityName}-${addressObj.areaName}`;
      return address;
    },

    async setPeopleScaleList() {
      const responseData = await this.$api.getEnterpriseEnumItems();
      this.peopleScaleList = responseData.scale_item_id.enumItems;
    },

    generateAcronym() {
      this.enterpriseForm.enterpriseCode = this.$js.pinyin.getCamelChars(
        this.enterpriseForm.enterpriseName
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.enterprise-form {
  width: 100%;

  .employee-scale,
  .industry {
    width: 100%;
  }

  .submit-button {
    width: 100%;
    margin: 20px 0;
    font-size: 18px;
    font-weight: 400;
    letter-spacing: 4px;
  }

  ::v-deep .city-picker {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}
</style>
